import type { SupportedLocale } from "./provider";

const INTL_LOCALE: Record<SupportedLocale, string> = {
  "sr-Latn": "sr-Latn-RS",
  "sr-Cyrl": "sr-Cyrl-RS",
  en: "en-US",
};

export function formatNumber(
  locale: SupportedLocale,
  value: number,
  options?: Intl.NumberFormatOptions,
): string {
  return new Intl.NumberFormat(INTL_LOCALE[locale], options).format(value);
}

export function formatCurrency(
  locale: SupportedLocale,
  value: number,
  currency: string,
): string {
  return new Intl.NumberFormat(INTL_LOCALE[locale], {
    style: "currency",
    currency,
    currencyDisplay: "code",
  }).format(value);
}

export function formatDate(
  locale: SupportedLocale,
  value: Date,
  options?: Intl.DateTimeFormatOptions,
): string {
  return new Intl.DateTimeFormat(INTL_LOCALE[locale], options ?? { dateStyle: "medium" }).format(
    value,
  );
}
